export default {
  accountMenu: {
    changeEnvironment: "Changer d'environnement",
    account: 'Compte',
    signIn: 'Se connecter',
    signOut: 'Se déconnecter',
    getSupport: "Obtenir de l'aide",
    settings: 'Paramètres',
    language: 'Langue',
    profile: 'Mon profil'
  },
  common: {
    search: 'Rechercher',
    close: 'Fermer',
    loading: 'Chargement',
    save: 'Enregistrer',
    cancel: 'Annuler',
    edit: 'Modifier',
    delete: 'Supprimer',
    add: 'Ajouter',
    yes: 'Oui',
    no: 'Non',
    ok: 'Ok',
    confirm: 'Confirmer',
    back: 'Retour',
    next: 'Suivant',
    finish: 'Terminer',
    apply: 'Appliquer',
    reset: 'Réinitialiser',
    refresh: 'Actualiser',
    retry: 'Réessayer',
    settings: 'Paramètres',
    submit: 'Soumettre',
    more: 'Plus',
    moreActions: "Plus d'actions",
    collapsedCrumbs: "Afficher tout le fil d'Ariane",
    editTitle: 'Modifier le titre',
    showMore: '+ {n} de plus',
    showLess: '- afficher moins',
    select: 'Sélectionner',
    multiplePaths: '{n} chemins',
    alternatePaths: 'Chemins alternatifs',
    copy: 'Copier',
    copyTo: 'Copier vers',
    duplicate: 'Dupliquer',
    moveLeft: 'Déplacer à gauche',
    moveRight: 'Déplacer à droite',
    scanQRCode: 'Scanner le QR code',
    sendRequest: 'Envoyer la demande',
    discard: 'Ignorer',
    unsavedChangesTitle: 'Ignorer les modifications non enregistrées ?',
    unsavedChangesMessage:
      'Vous avez des modifications non enregistrées qui seront perdues si vous quittez cette page.'
  },
  admin: {
    settings: 'Paramètres',
    dataImport: {
      preserveIds: 'Conserver les identifiants',
      preserveIdsDetails:
        'Conserve les identifiants des jumeaux et des relations du fichier importé. Les jumeaux existants ayant les mêmes identifiants seront mis à jour.'
    },
    catalog: {
      title: 'Catalogue de données'
    },
    dataSources: {
      title: 'Sources de données',
      add: 'Ajouter une source de données',
      empty: "Aucune source de données n'a été ajoutée à cet environnement."
    },
    environment: {
      tabs: {
        general: 'Général',
        deployment: 'Déploiement',
        apiKeys: 'Clés API',
        secrets: 'Secrets',
        certificates: 'Certificats',
        jobs: 'Tâches',
        configuration: 'Configuration'
      },
      backupRestore: {
        title: 'Restaurer une sauvegarde',
        description:
          "Sélectionnez un environnement ou téléversez un fichier de sauvegarde (.ndjson). La sauvegarde sera importée dans l'environnement actuel.",
        sourceCurrentEnv: 'Cet environnement',
        sourceOtherEnv: 'Un autre environnement',
        sourceFile: 'Depuis un fichier de sauvegarde',
        environmentLabel: 'Environnement',
        versionTimestamp: 'Date',
        versionSize: 'Taille',
        versionCurrent: 'Actuelle',
        restoreAction: 'Restaurer',
        downloadAction: 'Télécharger',
        noVersions: 'Aucune version de sauvegarde disponible',
        selectVersionHint: 'Sélectionnez une version à restaurer',
        fileDropLabel: 'Cliquez ou glissez un fichier de sauvegarde ici',
        fileDropHint: 'Format accepté : .ndjson',
        selectedFileLabel: 'Fichier sélectionné :',
        backupFileLabel: 'Fichier de sauvegarde :',
        outputFileLabel: 'Fichier de sortie :',
        startRestore: 'Démarrer la restauration',
        invalidFileType: 'Veuillez sélectionner un fichier de sauvegarde .ndjson valide.',
        uploadFailed: 'Échec du téléversement du fichier de sauvegarde.',
        uploadSuccess: 'Fichier de sauvegarde téléversé',
        copyUri: "Copier l'URI",
        uriCopied: 'URI de sauvegarde copiée dans le presse-papiers.',
        uriCopyFailed: "Échec de la copie de l'URI de sauvegarde.",
        triggerBackup: 'Déclencher la sauvegarde',
        triggerHint: 'Déclencher manuellement une sauvegarde de cet environnement.',
        backupTriggered: 'Sauvegarde déclenchée avec succès.'
      },
      apiKeys: {
        title: 'Clés API',
        newApiKey: 'Nouvelle clé API',
        update: 'Mettre à jour',
        regenerate: 'Régénérer',
        share: 'Partager',
        columns: {
          nameId: 'Nom (Id)',
          secret: 'Secret',
          roles: 'Rôles'
        },
        notify: {
          created: 'Clé API créée avec succès',
          updated: 'Clé API mise à jour avec succès',
          shared: 'Clé API partagée avec succès'
        },
        dialog: {
          regenerateTitle: 'Régénérer la clé API',
          regenerateConfirm: 'Êtes-vous sûr de vouloir régénérer cette clé API ?',
          deleteTitle: 'Supprimer la clé API',
          deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette clé API ?'
        }
      },
      secrets: {
        title: 'Secrets',
        newSecret: 'Nouveau secret',
        share: 'Partager',
        columns: {
          nameId: 'Nom (Id)',
          secretType: 'Type',
          secret: 'Secret'
        },
        notify: {
          created: 'Secret créé avec succès',
          shared: 'Secret partagé avec succès'
        },
        dialog: {
          deleteTitle: 'Supprimer le secret',
          deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce secret ?'
        }
      },
      certificates: {
        title: 'Certificats',
        newCertificate: 'Nouveau certificat',
        downloadPem: 'Télécharger (PEM)',
        downloadPfx: 'Télécharger (PFX)',
        update: 'Mettre à jour',
        regenerate: 'Régénérer',
        columns: {
          nameId: 'Nom (Id)',
          expiry: 'Expiration',
          thumbprint: 'Empreinte'
        },
        notify: {
          created: 'Certificat créé avec succès',
          updated: 'Certificat mis à jour avec succès'
        },
        dialog: {
          regenerateTitle: 'Régénérer le certificat',
          regenerateConfirm: 'Êtes-vous sûr de vouloir régénérer ce certificat auto-signé ?',
          deleteTitle: 'Supprimer le certificat',
          deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce certificat auto-signé ?'
        }
      },
      jobs: {
        downloadInput: "Télécharger l'entrée",
        downloadOutput: 'Télécharger la sortie',
        downloadFailed: 'Échec du téléchargement du fichier'
      }
    },
    devices: {
      onboarding: {
        eventGridInstance: 'Instance Event Grid',
        eventGridHint:
          'Sélectionnez le courtier MQTT Event Grid pour cet appareil (par défaut, le courtier du déploiement)',
        eventGridDefault: 'Défaut (automatique)',
        eventGridInvalid: 'Sélectionnez une instance Event Grid valide'
      }
    },
    models: {
      title: 'Modèles de données',
      loadFromRepo: 'Charger depuis le dépôt',
      upload: 'Télécharger',
      new: 'Nouveau',
      newModel: 'Nouveau modèle',
      extend: 'Étendre',
      deleteAll: 'Tout supprimer',
      export: 'Exporter',
      filter: 'Filtrer',
      view: 'Afficher',
      decommission: 'Désactiver',
      selectModelHint: 'Sélectionnez un modèle pour voir sa définition',
      addModels: 'Ajouter des modèles',
      addSuccess: '{count} modèle(s) ajouté(s)',
      errors: {
        empty: 'Collez un ou plusieurs modèles DTDL avant d’enregistrer.',
        invalidJson: 'Le contenu n’est pas un JSON valide.',
        addFailed: 'Les modèles n’ont pas pu être ajoutés.',
        refreshFailed: 'Les modèles ont été ajoutés, mais la liste n’a pas pu être actualisée.'
      },
      dialog: {
        decommissionTitle: 'Désactiver le modèle sélectionné',
        decommissionSingleConfirm: 'Êtes-vous sûr de vouloir désactiver ce modèle ? {models}',
        decommissionMultipleConfirm:
          'Êtes-vous sûr de vouloir désactiver tous ces modèles ? {models}',
        deleteSingleTitle: 'Supprimer le modèle sélectionné',
        deleteMultipleTitle: 'Supprimer tous les modèles sélectionnés',
        deleteSingleConfirm:
          'Êtes-vous sûr de vouloir supprimer le modèle sélectionné et ses dépendances ? {models}',
        deleteMultipleConfirm:
          'Êtes-vous sûr de vouloir supprimer tous les modèles sélectionnés et leurs dépendances ? {models}',
        deleteAllTitle: 'Supprimer tous les modèles',
        deleteAllConfirm: 'Êtes-vous sûr de vouloir supprimer tous les modèles ?'
      }
    },
    users: {
      newUsers: 'Nouveaux utilisateurs',
      exportRoles: 'Exporter les rôles',
      importRoles: 'Importer les rôles',
      filter: 'Filtrer',
      addRole: 'Ajouter un rôle',
      deleteRole: 'Supprimer le rôle',
      setKqlRole: 'Définir le rôle de base de données KQL',
      deleteKqlRole: 'Supprimer le rôle de base de données KQL',
      columns: {
        nameId: 'Nom (Id)',
        email: 'E-mail',
        status: 'Statut',
        roles: 'Rôles'
      },
      tabs: {
        all: 'Tous les utilisateurs',
        registered: 'Enregistrés',
        pending: 'En attente'
      },
      status: {
        registered: 'Enregistré',
        pending: 'En attente'
      },
      dialog: {
        deleteRoleTitle: 'Supprimer le rôle',
        deleteRoleMessage: 'Êtes-vous sûr de vouloir supprimer le rôle "{role}" de {user} ?',
        deleteAdxRoleTitle: 'Supprimer le rôle ADX',
        deleteAdxRoleMessage: 'Êtes-vous sûr de vouloir supprimer cette attribution de rôle ADX ?'
      },
      notify: {
        roleAdded: "Rôle {role} ajouté à l'utilisateur {user}",
        roleAddFailed: "Échec de l'ajout du rôle {role} à l'utilisateur {user}",
        roleDeleted: "Rôle {role} supprimé de l'utilisateur {user}",
        roleDeleteFailed: "Échec de la suppression du rôle {role} de l'utilisateur {user}",
        adxRoleAssigned: "Rôle {role} attribué à l'utilisateur {user} dans la base de données KQL",
        adxRoleAssignFailed:
          "Échec de l'attribution du rôle {role} à l'utilisateur {user} dans la base de données KQL",
        adxRoleDeleted: "Rôle {role} supprimé de l'utilisateur {user} dans la base de données KQL",
        adxRoleDeleteFailed:
          "Échec de la suppression du rôle {role} de l'utilisateur {user} dans la base de données KQL",
        addUsersFailed: "Échec de l'ajout de {count} rôles d'utilisateur",
        addUsersSuccess: "{count} rôles d'utilisateur ajoutés",
        adxRolesFailed: 'Échec du chargement des rôles ADX pour les utilisateurs'
      }
    },
    features: {
      filter: 'Filtrer',
      editFeature: 'Modifier la fonctionnalité',
      reorderFeatures: 'Réorganiser les fonctionnalités',
      doneReordering: 'Terminé',
      reorderHint: 'Glisser pour réorganiser',
      orderNumber: 'Ordre {order}',
      reorderClearFilter: 'Effacez le filtre pour réorganiser les fonctionnalités',
      reorderFailed: "Impossible d'enregistrer le nouvel ordre des fonctionnalités"
    },
    files: {
      upload: 'Télécharger le fichier',
      download: 'Télécharger le fichier',
      preview: 'Aperçu du fichier',
      noConfigurationProperties:
        "Aucune propriété de configuration trouvée pour ce type d'environnement."
    }
  },
  relations: {
    editRelationship: 'Modifier la relation',
    deleteRelationship: 'Supprimer la relation',
    deleteRelationshipConfirm: 'Êtes-vous sûr de vouloir supprimer cette relation ?'
  },
  files: {
    upload: 'Télécharger',
    linkAutodeskFile: 'Lier un fichier Autodesk',
    files: 'Fichiers',
    contextMenu: {
      viewFile: 'Afficher le fichier',
      viewOnAcc: 'Afficher le fichier sur ACC',
      downloadFile: 'Télécharger le fichier',
      fileVersions: 'Versions du fichier',
      uploadNewVersion: 'Télécharger une nouvelle version',
      versionItem: 'v{version} : {date} par {name}'
    },
    uploadDialog: {
      titleImages: 'Télécharger des images',
      titleFiles: 'Télécharger des fichiers',
      pickImages: 'Choisir des images',
      pickFiles: 'Choisir des fichiers',
      submit: 'Télécharger'
    },
    uploadVersionDialog: {
      title: 'Télécharger une nouvelle version',
      pickFile: 'Choisir un fichier',
      submit: 'Télécharger'
    },
    linkDialog: {
      title: 'Lier un fichier Autodesk',
      submit: 'Lier'
    },
    linkOneLakeFile: 'Lier un fichier OneLake',
    linkOneLakeFileDialog: {
      title: 'Lier un fichier OneLake',
      submit: 'Lier'
    }
  },
  flows: {
    shared: 'Partagé',
    nonDurable: 'Non durable',
    disabled: 'Désactivé',
    duplicate: 'Dupliquer',
    export: 'Exporter',
    import: 'Importer',
    enable: 'Activer',
    disable: 'Désactiver',
    share: 'Partager',
    columns: {
      name: 'Nom',
      lastRun: 'Dernière exécution',
      status: 'Statut'
    },
    dialog: {
      deleteTitle: 'Supprimer le flux',
      deleteConfirm: 'Êtes-vous sûr de vouloir supprimer {name} ?',
      deleteSelectedTitle: 'Supprimer les flux sélectionnés',
      deleteSelectedConfirm: 'Êtes-vous sûr de vouloir supprimer {count} flux ?',
      enableTitle: 'Activer les flux sélectionnés',
      enableConfirm: 'Êtes-vous sûr de vouloir activer tous ces flux ({count}) ?',
      disableTitle: 'Désactiver les flux sélectionnés',
      disableConfirm: 'Êtes-vous sûr de vouloir désactiver tous ces flux ({count}) ?'
    },
    importDialog: {
      title: 'Importer des flux',
      fileLabel: 'Fichier(s) de flux',
      overwrite: 'Écraser les flux existants ?',
      invalidFile: 'Fichier invalide'
    },
    copilot: {
      tabLabel: 'Copilote',
      welcomeTitle: 'Copilote de configuration de flux',
      welcomeSubtitle: 'Je peux vous aider à configurer et dépanner ce flux'
    },
    clear: 'Effacer',
    run: 'Exécuter',
    runWithPayload: 'Exécuter avec charge utile',
    nothingSelected: 'Rien de sélectionné',
    activitiesSelected: '{count} activité sélectionnée | {count} activités sélectionnées',
    relationshipsSelected: '{count} relation sélectionnée | {count} relations sélectionnées',
    layoutGraph: 'Disposition du graphe',
    topToBottom: 'Haut en bas',
    leftToRight: 'Gauche à droite',
    relayout: 'Réorganiser',
    nonDurableExecution: 'Exécution non durable',
    nonDurableTooltip:
      "L'exécution non durable est plus rapide pour les petites charges utiles, mais moins résiliente. Recommandé uniquement pour les flux de courte durée.",
    disabledTooltip: 'Désactiver le flux (empêche toute nouvelle exécution)',
    enableTooltip: 'Le flux est désactivé. Cliquez pour activer.',
    newFlow: 'Nouveau flux',
    flowsLabel: 'Flux',
    tabs: {
      payloads: 'Charges utiles',
      activity: 'Activité',
      logs: 'Journaux',
      runs: 'Exécutions'
    },
    notify: {
      saved: 'Flux enregistré',
      imported: '{count} flux importé(s)',
      shared: 'Flux partagé avec succès',
      flowCreated: 'Flux créé',
      activityTriggered: 'Activité déclenchée',
      copiedToClipboard: 'Copié dans le presse-papiers',
      cutToClipboard: 'Coupé dans le presse-papiers',
      invalidDataFormat: 'Format de données invalide'
    }
  },
  languages: {
    en: 'Anglais',
    fr: 'Français',
    nl: 'Néerlandais'
  },
  history: {
    updatedBy: 'Mis à jour par {user}'
  },
  viewer: {
    catalogBrowser: {
      title: 'Catalogue de données',
      open: 'Parcourir le catalogue de données',
      sources: {
        title: 'Sources du catalogue',
        empty: 'Aucune source de catalogue n’est disponible.',
        smartAtlas: 'Smart Atlas',
        oneLake: 'OneLake',
        autodesk: 'Autodesk Construction Cloud'
      },
      collections: {
        title: 'Collections',
        empty:
          'Aucun résultat ne correspond à votre recherche, ou cette source ne contient aucune collection.',
        error: 'Les collections n’ont pas pu être chargées.'
      },
      items: {
        title: 'Éléments',
        empty:
          'Aucun résultat ne correspond à votre recherche, ou cette collection ne contient aucun élément.',
        error: 'Les éléments n’ont pas pu être chargés.'
      },
      tree: {
        searching: 'Recherche dans l’arborescence…',
        searchLimited:
          'La recherche n’a couvert qu’une partie de l’arborescence. Développez un dossier pour chercher à l’intérieur.'
      },
      preview: {
        alt: 'Aperçu de {name}'
      },
      item: {
        modelUnavailable: 'Non disponible dans cet environnement',
        source: 'Source',
        selectableVariants: 'Sélectionner des variantes'
      }
    },
    modelVersion: {
      title: 'Version du modèle',
      version: 'Version',
      latestHint: 'Laisser vide pour charger la dernière version à chaque ouverture du modèle.',
      viewable: 'Vue',
      loadError:
        'Les versions du modèle n’ont pas pu être chargées depuis Autodesk Construction Cloud.',
      currentVersionMissing:
        'La version utilisée par ce modèle n’existe plus dans Autodesk Construction Cloud. Choisissez une version pour continuer.',
      saveError: 'La version du modèle n’a pas pu être enregistrée.'
    },
    catalogLink: {
      configuration: {
        title: 'Configuration de la couche',
        modelTitle: 'Configuration du modèle',
        back: 'Retour au catalogue',
        variable: 'Variable',
        dimensionSelector: 'Selecteur de dimensions',
        layerCount: 'Ajoute {count} couche | Ajoute {count} couches',
        variantDimensionRequired: 'Choisissez au moins une option pour {dimension}.',
        variantLimit: 'Selectionnez au maximum {count} combinaisons de couches a la fois.',
        variableRequired: "Selectionnez une variable avant d'ajouter cette couche.",
        customizeStyling: 'Personnaliser le style',
        partialCompletion:
          '{count} couche ajoutee avant l echec. Reessayez pour continuer avec les couches restantes.'
      },
      submit: 'Ajouter la couche | Ajouter {count} couches',
      submitModel: 'Ajouter le modèle'
    },
    label: {
      model: 'Modèle',
      map: 'Carte'
    },
    menu: 'Menu',
    openModelOf: 'Ouvrir le modèle de',
    openPanel: 'Couches',
    mapActionsLabel: 'Actions de carte',
    scrollZoomInteractionTooltip:
      'Activer ou désactiver le zoom par défilement. Lorsqu’il est désactivé, maintenez Ctrl (Cmd sur Mac) enfoncé pendant le défilement pour zoomer.',
    sourceOptions: {
      autodesk: {
        label: 'Lier Autodesk Construction Cloud',
        description: 'Lier un modèle 3D ou 2D existant hébergé sur Autodesk Construction Cloud.'
      },
      spatialData: {
        label: 'Télécharger des données spatiales',
        description: 'Télécharger des données spatiales (GeoJSON, KML, KMZ, ...).'
      },
      tileLayer: {
        label: 'Lier une couche de tuiles',
        description:
          "Lier une couche d'images tramées hébergée via une source TileJSON ou une URL paramétrisée."
      },
      vectorLayer: {
        label: 'Lier une couche vectorielle',
        description:
          'Lier une couche de tuiles vectorielles hébergée via une source TileJSON ou des URL paramétrisées.'
      },
      esriFeatureServer: {
        label: 'Lier un serveur ESRI Feature Server',
        description: 'Lier un serveur ESRI Feature Server hébergé.'
      },
      smartAtlasProject: {
        label: 'Lier un projet Smart Atlas',
        description: 'Lier un projet Arcadis Smart Atlas.'
      },
      geoTiff: {
        label: 'Télécharger un GeoTIFF',
        description: 'Télécharger un GeoTIFF optimisé pour le cloud pour la tuile dynamique.'
      },
      oneLakeGeoTiff: {
        label: 'Lier un GeoTIFF OneLake',
        description:
          'Lier un GeoTIFF optimisé pour le cloud stocké dans OneLake pour la tuile dynamique.'
      },
      oneLakeSpatialData: {
        label: 'Lier des données spatiales OneLake',
        description: 'Lier des données spatiales (GeoJSON, KML, KMZ, ...) stockées dans OneLake.'
      },
      stac: {
        label: 'Lier une couche STAC',
        description:
          'Lier un élément du SpatioTemporal Asset Catalog (STAC) pour la tuile dynamique.'
      },
      multidim: {
        label: 'Lier une couche multidimensionnelle',
        description:
          'Lier un jeu de données multidimensionnel (NetCDF, GRIB, Zarr, Kerchunk) pour la tuile dynamique.'
      },
      multidimUpload: {
        label: 'Télécharger un fichier multidimensionnel',
        description:
          'Télécharger un fichier NetCDF (.nc) pour la tuile dynamique multidimensionnelle.'
      }
    },
    stac: {
      stacUrlLabel: 'URL STAC',
      stacUrlHint: "URL de l'élément ou de la collection STAC.",
      variableLabel: "Variable (clé d'asset)",
      variableHint: "Clé d'asset facultative dans l'élément STAC à afficher.",
      variableDetecting: 'Détection des assets…',
      variableManualHint: 'La détection automatique a échoué. Saisissez la clé manuellement.',
      stacAssetsLabel: "Clés d'asset (séparées par des virgules)",
      stacAssetsHint: "Liste facultative de clés d'asset séparées par des virgules.",
      stacAssetsDetecting: 'Détection des assets…',
      stacAssetsManualHint: 'La détection automatique a échoué. Saisissez les clés manuellement.',
      dimensionSelectorLabel: 'Sélecteur de dimension',
      dimensionKeyLabel: 'Dimension',
      dimensionValueLabel: 'Valeur',
      addDimension: 'Ajouter une dimension',
      styleLabel: 'Style',
      opacityLabel: 'Opacité',
      rescaleLabel: 'Redimensionner (min,max)',
      rescalePlaceholder: 'ex. 0,1000',
      rescaleHint:
        "Plage min,max optionnelle séparée par des virgules pour la mise à l'échelle d'affichage.",
      colorMapLabel: 'Palette de couleurs',
      colorMapHint:
        'Palette de couleurs rio-tiler optionnelle. Laisser vide pour utiliser les bandes RGB.'
    },
    multidim: {
      sourceUrlLabel: 'URL source',
      sourceUrlHint: 'URL du jeu de données multidimensionnel.',
      sourceFormatLabel: 'Format source',
      sourceFormatHint: 'Format du jeu de données multidimensionnel.',
      variableLabel: 'Variable',
      variableHint: 'Nom de la variable à afficher.',
      variableDetecting: 'Détection des variables…',
      variableManualHint: 'La détection automatique a échoué. Saisissez le nom manuellement.',
      dimensionDetecting: 'Détection des dimensions…',
      dimensionAutoHint: 'Dimensions détectées automatiquement. Ajustez les valeurs si nécessaire.',
      dimensionFillError:
        'Échec de la détection des dimensions. Utilisez le formulaire ci-dessous.',
      dimensionSelectorLabel: 'Sélecteur de dimension',
      dimensionKeyLabel: 'Dimension',
      dimensionValueLabel: 'Valeur',
      addDimension: 'Ajouter une dimension',
      styleLabel: 'Style',
      opacityLabel: 'Opacité',
      rescaleLabel: 'Redimensionner (min,max)',
      rescalePlaceholder: 'ex. 0,1000',
      rescaleHint:
        "Plage min,max optionnelle séparée par des virgules pour la mise à l'échelle d'affichage.",
      colorMapLabel: 'Palette de couleurs',
      colorMapHint:
        'Palette de couleurs rio-tiler optionnelle. Laisser vide pour utiliser les bandes RGB.'
    },
    multidimUpload: {
      fileLabel: 'Choisir un/des fichier(s) NetCDF',
      fileHint:
        'Formats supportés : <code>.nc</code>, <code>.nc4</code>. Vous pouvez sélectionner plusieurs fichiers — ils partageront la même configuration.',
      sourceFormatLabel: 'Format source',
      variableLabel: 'Variable',
      variableHint: 'Nom de la variable à afficher.',
      dimensionSelectorLabel: 'Sélecteur de dimension',
      dimensionKeyLabel: 'Dimension',
      dimensionValueLabel: 'Valeur',
      addDimension: 'Ajouter une dimension',
      styleLabel: 'Style',
      opacityLabel: 'Opacité',
      rescaleLabel: 'Redimensionner (min,max)',
      rescalePlaceholder: 'ex. 0,1000',
      rescaleHint:
        "Plage min,max optionnelle séparée par des virgules pour la mise à l'échelle d'affichage.",
      colorMapLabel: 'Palette de couleurs',
      colorMapHint:
        'Palette de couleurs rio-tiler optionnelle. Laisser vide pour utiliser la palette par défaut.'
    },
    oneLakeFile: {
      styleLabel: 'Style',
      opacityLabel: 'Opacité',
      rescaleLabel: 'Redimensionner (min,max)',
      rescalePlaceholder: 'ex. 0,1000',
      rescaleHint:
        "Plage min,max optionnelle séparée par des virgules pour la mise à l'échelle d'affichage.",
      colorMapLabel: 'Palette de couleurs',
      colorMapHint:
        'Palette de couleurs rio-tiler optionnelle. Laisser vide pour utiliser les bandes RGB.',
      hazardPaletteLabel: 'Palette de couleurs des aléas Nexus',
      hazardPaletteHint:
        "Applique les couleurs de la jauge d'exposition pour un aléa Nexus. Conçue pour un percentile 0–100 avec un redimensionnement 0,100.",
      hazardPalettes: {
        wind: 'Vent',
        wildfire: 'Feu de forêt',
        heat: 'Chaleur',
        cold: 'Froid',
        precipitation: 'Précipitations',
        flooding: 'Inondation',
        hail: 'Grêle',
        drought: 'Sécheresse',
        'global-risk': 'Percentile de risque global'
      }
    },
    controls: {
      buildings3dShow: 'Afficher les bâtiments 3D',
      buildings3dHide: 'Masquer les bâtiments 3D',
      trafficShow: 'Afficher le trafic',
      trafficHide: 'Masquer le trafic',
      weatherShow: 'Afficher la couche météo',
      weatherActive: 'Couche météo {type} active (cliquer pour masquer)',
      weatherNone: 'Aucun',
      weatherRadar: 'Radar',
      weatherInfrared: 'Infrarouge',
      demShow: 'Afficher l’élévation du terrain (MNT)',
      demHide: 'Masquer l’élévation du terrain (MNT)'
    },
    detailsPanel: {
      title: 'Détails',
      empty: 'Sélectionnez un objet sur la carte pour afficher ses détails.'
    },
    legend: {
      title: 'Légende',
      noData: 'Aucune donnée',
      minimize: 'Réduire la légende',
      expand: 'Déployer la légende',
      loading: 'Chargement de la légende…',
      loadError: 'Légende indisponible',
      filterHide: 'Filtrer cette classe de la carte',
      filterShow: 'Afficher cette classe sur la carte',
      filterReset: 'Afficher toutes les classes'
    },
    graph: {
      empty:
        'Aucun jumeau à afficher. Parcourez ou sélectionnez un jumeau pour voir son graphe de relations.',
      layout: 'Disposition',
      layouts: {
        klay: 'Hiérarchique',
        breadthfirst: 'Par largeur',
        circle: 'Cercle',
        concentric: 'Concentrique',
        cose: 'Dirigée par force',
        grid: 'Grille'
      },
      fetchIncoming: 'Récupérer les relations entrantes {relationship}',
      fetchOutgoing: 'Récupérer les relations sortantes {relationship}',
      fetchIncomingAll: 'Récupérer les relations entrantes',
      fetchOutgoingAll: 'Récupérer les relations sortantes'
    },
    viewerDataPanel: {
      title: 'Couches',
      filterPlaceholder: 'Filtrer les couches',
      findLayerPlaceholder: 'Rechercher une couche',
      source: 'Source : {source}',
      opacity: 'Opacité : {pct} %',
      ungrouped: 'Non groupé',
      show: 'Afficher',
      hide: 'Masquer',
      map: 'Carte',
      threeD: '3D',
      graph: 'Graphique',
      mapLayers: 'Couches de la carte',
      groupCount: '{loaded} sur {total} couches chargées',
      twinsLayer: 'Données de la tuile',
      menu: {
        trigger: 'Gérer la couche'
      },
      samePanelLayout: {
        label: 'Disposition des panneaux du même côté',
        tabs: 'Onglets (combiné)',
        split: 'Séparé (panneaux distincts)',
        description:
          "Disposition des panneaux de couches et de légende lorsqu'ils sont du même côté."
      }
    },
    alignment: {
      menuItem: 'Ajuster l’alignement du modèle',
      title: 'Aligner le modèle',
      description:
        'Déplacez le modèle et ajustez son échelle pour l’aligner avec les autres couches. L’alignement est enregistré sur le modèle et appliqué à chaque chargement.',
      positionHeading: 'Position',
      rotationHeading: 'Rotation',
      offsetX: 'Décalage X',
      offsetY: 'Décalage Y',
      offsetZ: 'Décalage Z',
      rotationX: 'Rotation X',
      rotationY: 'Rotation Y',
      rotationZ: 'Rotation Z',
      metres: 'm',
      degrees: '°',
      factor: '×',
      scale: 'Échelle',
      scaleHint: '1 conserve la taille d’origine, 2 la double, 0,5 la réduit de moitié',
      invalidScale: 'L’échelle doit être supérieure à 0'
    },
    geoTiffStyling: {
      menuItem: 'Ajuster le style de la couche',
      title: 'Style de la couche',
      rasterHeading: 'Paramètres raster',
      rasterHint: 'Contrôlez la plage de zoom source et la taille des tuiles.',
      tileMinSourceZoomLabel: 'Zoom source minimal',
      tileMaxSourceZoomLabel: 'Zoom source maximal',
      tileScaleLabel: 'Échelle des tuiles',
      tileScaleHint: '1 utilise des tuiles de 256 x 256 pixels.',
      suggestRescale: 'Suggérer une mise à l’échelle à partir des statistiques p2-p98',
      statisticsUnavailable: 'Les statistiques ne sont pas disponibles pour cette couche.',
      statisticsError: 'Impossible de suggérer une plage de mise à l’échelle.'
    }
  },
  formTile: {
    keyValueArray: {
      keyLabel: 'Clé',
      value: 'Valeur',
      add: 'Ajouter',
      edit: 'Modifier',
      remove: 'Supprimer',
      confirm: 'Confirmer',
      cancel: 'Annuler',
      empty: "Aucune entrée pour l'instant.",
      duplicateKey: 'Cette clé existe déjà.'
    }
  },
  dashboard: {
    toolbar: {
      new: 'Nouveau',
      more: 'Plus',
      newParameter: 'Nouveau paramètre',
      newTile: 'Nouvelle tuile',
      configuration: 'Configuration',
      savePictures: 'Sauvegarder les images',
      saveLayout: 'Sauvegarder la mise en page',
      sharedQueries: 'Requêtes partagées',
      print: 'Imprimer',
      slider: 'Curseur',
      rangeSlider: 'Curseur de plage',
      openEditor: 'Éditeur de tableau de bord'
    }
  },
  gaugeTile: {
    minimum: 'Min : {value}',
    maximum: 'Max : {value}'
  },
  treeTable: {
    name: 'Nom',
    actions: 'Actions',
    columns: 'Colonnes',
    collapse: 'Réduire',
    collapseAll: 'Tout réduire',
    expand: 'Développer',
    expandAll: 'Tout développer',
    filter: 'Filtrer',
    goTo: 'Ouvrir',
    groupBy: 'Grouper par',
    noData: 'Aucune ligne ne correspond aux filtres appliqués.',
    truncated:
      'Plus de lignes qu’il n’est possible d’afficher — {count} masquées. Réduisez une branche ou groupez à un niveau supérieur.'
  },
  treeTableFeature: {
    title: 'Tableau hiérarchique',
    mode: 'Mode d’affichage',
    browse: 'Parcourir',
    customQuery: 'Requête',
    queryKind: 'Type de requête',
    execute: 'Exécuter',
    open: 'Ouvrir'
  },
  lazyExtension: {
    loadFailed: "Une partie de cette page n'a pas pu être chargée. Réessayez."
  },
  optionPicker: {
    select: 'Sélectionner…',
    loading: 'Chargement…',
    empty: 'Aucune option disponible',
    error: 'Impossible de charger les options',
    clear: 'Effacer',
    confirmTitle: 'Veuillez confirmer',
    confirmDefault: 'Voulez-vous continuer ?',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    failed: "L'action a échoué"
  },
  jetconnect: {
    assignPlaceholder: 'Assigner un POC…',
    floor: 'Étage {floor}',
    capacityLeft: 'Reste {amount} {unit} après',
    capacityShort: 'Manque {amount} {unit}',
    distanceMetres: '{distance} m',
    distanceViewerUnits: '{distance} unités du viewer',
    distanceUnknown: 'Distance inconnue',
    notInViewer: 'Absent du modèle 3D : à assigner manuellement',
    insufficientCapacity: 'Capacité insuffisante',
    viewerLoading: 'Chargement du viewer…',
    pocsLoading: 'Chargement des POC…',
    pocsError: 'Impossible de charger les POC',
    rankError: 'Impossible de classer les POC',
    noCandidates: 'Aucun POC compatible pour {serviceCode}',
    noCandidatesInRange: 'Aucun POC compatible à moins de {max} m',
    filterUncalibrated:
      "Filtre de distance non appliqué : la distance du viewer n'est pas calibrée en mètres",
    writeFailed: "Échec de l'assignation : {reason}",
    noConnection: "Cette ligne n'est pas une connexion",
    assigned: 'Assigné à {poc}',
    unassigned: 'Assignation supprimée',
    confirmOverCapacity:
      "{poc} n'a plus assez de capacité pour cette connexion. Assigner quand même ? Sa capacité restante deviendra négative.",
    autoAssign: {
      blocked: 'Pas encore disponible : {reason}',
      button: 'Affectation auto',
      buttonBlocked: 'Affectation auto ({reason})',
      noTool: 'sélectionnez un outil',
      dataLoading: 'chargement des données…',
      loadError: 'les données n’ont pas pu être chargées',
      unavailable: 'L’affectation automatique n’est pas disponible ici',
      title: 'Affecter automatiquement les raccordements',
      scopeTool: 'Outil entier · raccordements non affectés : {count}',
      scopeSelection: 'Sélection · raccordements non affectés : {count}',
      onlySelected: 'Uniquement les raccordements sélectionnés ({count})',
      summary:
        '{assigned} à affecter · {unassignable} non affectables · {skipped} déjà affectés (ignorés)',
      plannedTitle: 'Affectations prévues',
      unassignableTitle: 'Non affectables',
      nothing:
        'Rien à affecter : chaque raccordement du périmètre est déjà affecté ou ne peut pas être placé.',
      colConnection: 'Raccordement',
      colSystem: 'Système',
      colRequired: 'Requis',
      colCapacity: 'Capacité restante',
      colReason: 'Motif',
      pocCapacity: '{before} → {after} {unit}',
      pocUsed: 'Raccordements : {count} · {used} {unit}',
      distanceUnknownNote:
        '{count} affectations prévues utilisent un POC dont la distance est inconnue ; elles sont listées en dernier.',
      confirm: 'Affecter {count}',
      cancel: 'Annuler',
      close: 'Fermer',
      undo: 'Annuler l’affectation',
      undoCount: 'Annuler {count}',
      progress: 'Affectation… {done} / {total}',
      undoProgress: 'Annulation… {done} / {total}',
      resultAssigned: 'Raccordements affectés : {count}',
      resultFailed: '{count} en échec',
      resultAlready: '{count} ont été affectés entre-temps et sont restés inchangés',
      tableRefresh: 'Le tableau se met à jour dans quelques secondes.',
      undone: 'Affectations annulées : {count}',
      undoStateChanged: '{count} laissés inchangés car modifiés depuis l’exécution',
      undoFailed: '{count} n’ont pas pu être annulés',
      failed: 'L’affectation automatique a échoué : {message}',
      reason: {
        'no-capacity': 'Aucun POC de ce système n’a assez de capacité restante',
        'no-matching-system': 'Aucun POC n’existe pour ce système',
        'unit-mismatch': 'Aucun POC de ce système n’utilise la même unité',
        'distance-unavailable': 'Seuls des POC à distance inconnue ont de la capacité',
        'invalid-requirement': 'Le débit requis est absent ou n’est pas un nombre'
      }
    }
  },
  table: {
    toolbar: {
      links: 'Liens',
      import: 'Importer',
      more: 'Plus',
      editQueries: 'Modifier les requêtes',
      newQuery: 'Nouveau',
      createNewFeatureQuery: 'Créer une nouvelle requête de fonctionnalité',
      saveFeatureQueries: 'Enregistrer les requêtes de fonctionnalité',
      queryAll: 'Tout interroger',
      queryAllWithFilters: 'Tout interroger avec filtres',
      newFolder: 'Nouveau dossier',
      new: 'Nouveau',
      createNewTwin: 'Créer un nouveau jumeau',
      addMultipleTwins: 'Ajouter plusieurs jumeaux',
      editTwin: 'Modifier le jumeau sélectionné',
      editTwins: 'Modifier les jumeaux sélectionnés',
      move: 'Déplacer',
      moveTwin: 'Déplacer le jumeau sélectionné',
      moveTwins: 'Déplacer les jumeaux sélectionnés',
      duplicate: 'Dupliquer',
      duplicateTwin: 'Dupliquer le jumeau sélectionné',
      deleteTwin: 'Supprimer le jumeau sélectionné',
      deleteTwins: 'Supprimer les jumeaux sélectionnés',
      clear: 'Effacer',
      clearSelection: 'Effacer la sélection',
      addMarker: 'Ajouter un marqueur',
      addMarkerTooltip: 'Ajouter un marqueur dans la visionneuse',
      removeMarker: 'Supprimer le marqueur',
      removeMarkerTooltip: 'Supprimer le marqueur du jumeau sélectionné dans la visionneuse',
      linkTwinToObject: 'Lier le jumeau à un objet',
      linkTwinToObjectTooltip: 'Lier le jumeau sélectionné à un objet dans la visionneuse',
      removeLink: 'Supprimer le lien',
      removeLinkTooltip: 'Supprimer le lien entre le jumeau sélectionné et la visionneuse',
      linkTwinsByProperty: 'Lier les jumeaux par propriété',
      linkTwinsByPropertyTooltip: 'Lier les jumeaux aux objets dans la visionneuse par propriété',
      removeLinksByProperty: 'Supprimer les liens par propriété',
      removeLinksByPropertyTooltip: 'Supprimer les jumeaux liés dans la visionneuse par propriété',
      updateTwinsByProperty: 'Mettre à jour les jumeaux par propriété',
      updateTwinsByPropertyTooltip:
        'Mettre à jour les jumeaux liés avec les données de la visionneuse',
      importFromFile: 'Importer depuis un fichier',
      importFromFileTooltip:
        'Importer des données de jumeaux depuis un fichier (CSV, Excel, JSON, ...)',
      uploadFilesFromFolder: 'Télécharger des fichiers depuis un dossier',
      importSelectedObjectsOld: 'Importer les objets sélectionnés depuis la visionneuse (ancien)',
      importAllObjectsOld: 'Importer tous les objets depuis la visionneuse (ancien)',
      importSelectedObjects: 'Importer les objets sélectionnés depuis la visionneuse',
      importAllObjects: 'Importer tous les objets depuis la visionneuse',
      export: 'Exporter',
      restoreViewerState: "Restaurer l'état de la visionneuse",
      saveViewerState: "Enregistrer l'état de la visionneuse",
      uploadFiles: 'Télécharger des fichiers',
      linkAutodeskFile: 'Lier un fichier Autodesk',
      generateQRCode: 'Générer un code QR',
      generateQRCodesBulk: 'Générer des codes QR (en masse)'
    }
  },
  chat: {
    header: {
      toggle: 'Activer le chat IA'
    },
    drawer: {
      title: 'Assistant IA',
      clearChat: 'Nouvelle session',
      tryAsking: 'Essayez de demander :',
      aiAssistantName: 'Assistant IA',
      errorOccurred: 'Une erreur est survenue. Veuillez réessayer.',
      retry: 'Réessayer',
      typeMessage: 'Tapez un message...',
      sendMessage: 'Envoyer le message',
      stopGenerating: 'Arrêter la génération',
      disclaimer: "L'IA peut faire des erreurs. Vérifiez les informations importantes.",
      you: 'Vous',
      welcomeTitle: 'Assistant Jumeaux Numériques',
      climateRiskTitle: 'Assistant Risques Climatiques',
      welcomeSubtitle:
        'Je peux vous aider à explorer et comprendre vos données de jumeaux numériques',
      climateRiskSubtitle:
        'Je peux vous aider à comprendre les aléas climatiques et les scores de risque',
      envSuffix: ' dans ',
      defaultSuggestion1: "Comment pouvez-vous m'aider ?",
      defaultSuggestion2: 'Comment interroger les jumeaux numériques ?',
      defaultSuggestion3: 'Montrez-moi les données disponibles',
      climateRiskSuggestion1: 'Comment le score de chaleur est-il calculé ?',
      climateRiskSuggestion2: 'Comment les scores sont-ils étalonnés ?',
      climateRiskSuggestion3:
        "Quels indicateurs d'aléas sont utilisés pour les inondations côtières ?",
      modelLabel: 'Modèle',
      continueWithModel: 'Continuer avec un autre modèle'
    },
    toolCall: {
      executing: 'En cours...',
      error: 'Erreur',
      completed: 'Terminé',
      awaitingApproval: 'En attente d’approbation',
      rejected: 'Rejeté',
      approvalReason: 'Motif de rejet facultatif',
      approve: 'Approuver',
      reject: 'Rejeter',
      input: 'Entrée',
      output: 'Sortie'
    },
    flowPreview: {
      title: 'Modifications appliquées',
      activitiesChanged: '{count} activité modifiée | {count} activités modifiées',
      keep: 'Conserver',
      undo: 'Annuler'
    },
    tilePreview: {
      title: 'Aperçu de la tuile',
      unsupported: 'Aperçu non disponible pour {type}.',
      addToDashboard: 'Ajouter au tableau de bord',
      addedToDashboard: 'Tuile "{name}" ajoutée au tableau de bord.',
      addFailed: "Échec de l'ajout de la tuile au tableau de bord.",
      noDashboard: 'Aucun tableau de bord actif.',
      openEditor: "Ouvrir l'éditeur"
    },
    dashboardPreview: {
      title: 'Modifications appliquées',
      tilesChanged: '{count} tuile modifiée | {count} tuiles modifiées',
      keep: 'Conserver',
      undo: 'Annuler'
    },
    sessions: {
      title: 'Historique des conversations',
      history: 'Historique des conversations',
      empty: 'Aucune conversation précédente',
      untitled: 'Conversation sans titre',
      messageCount: '{count} message | {count} messages',
      loadError: 'Impossible de charger la conversation',
      deleteError: 'Impossible de supprimer la conversation'
    },
    attachments: {
      attachFiles: 'Joindre des fichiers',
      dropFiles: 'Deposez les fichiers pour les joindre',
      removeAttachment: 'Retirer la pièce jointe'
    }
  },
  runtimeParameters: {
    malformedMultiValue: 'Le paramètre "{name}" contient une sélection multiple non valide.'
  },
  featureEditor: {
    title: 'Éditeur de fonctionnalité',
    preview: 'Aperçu',
    save: 'Enregistrer les modifications',
    discard: 'Annuler',
    back: 'Retour à la fonctionnalité',
    backToParent: 'Retour à la fonctionnalité parente',
    unsavedChanges: 'Modifications non enregistrées',
    saved: '{count} modification enregistrée | {count} modifications enregistrées',
    saveFailed:
      "{count} modification n'a pas pu être enregistrée | {count} modifications n'ont pas pu être enregistrées",
    retry: 'Réessayer',
    sharedWarning:
      'Cette fonctionnalité est réutilisée par {count} autre fonctionnalité | Cette fonctionnalité est réutilisée par {count} autres fonctionnalités. Les modifications les affectent toutes.',
    upstreamChanged:
      'Cette fonctionnalité a été modifiée ailleurs pendant votre édition. Enregistrer maintenant risque d’écraser ces modifications.',
    reloadFromServer: 'Recharger depuis le serveur',
    editingDashboard: 'Fonctionnalité en cours de modification',
    noCopyTargets: 'Aucun autre tableau de bord',
    previewHint:
      'Affiche le tableau de bord en lecture seule, exactement comme les utilisateurs le verront : les tuiles ne peuvent pas être déplacées ni redimensionnées, les tuiles masquées par leur expression de masquage restent masquées et la taille automatique / le flottement restent actifs. Désactivé révèle toutes les tuiles afin que la disposition reste entièrement modifiable.',
    parameters: {
      title: 'Paramètres',
      add: 'Ajouter un paramètre',
      empty: 'Aucun paramètre',
      label: 'Libellé',
      name: 'Nom de variable',
      kind: 'Type',
      displayStyle: "Style d'affichage",
      defaultValue: 'Valeur par défaut',
      remove: 'Supprimer le paramètre',
      configuration: 'Configuration',
      currentValue: 'Valeur actuelle',
      listView: 'Liste des paramètres',
      contextView: "Contexte d'expression",
      currentValueHint: "Valeur d'exécution résolue. Cette vue est en lecture seule.",
      noCurrentValue: "Aucune valeur actuelle n'a été résolue pour ce paramètre.",
      copyCurrentValue: 'Copier la valeur actuelle',
      currentValueCopied: 'Valeur actuelle du paramètre copiée dans le presse-papiers'
    },
    queries: {
      title: 'Requêtes partagées',
      add: 'Ajouter une requête partagée',
      empty: 'Aucune requête partagée',
      addQuery: 'Ajouter une requête',
      emptyQueries: 'Aucune requête'
    },
    deleteTileConfirm:
      'Supprimer la tuile "{name}" du brouillon ? Elle sera supprimée lors de l\'enregistrement.',
    tile: {
      unnamed: 'Tuile sans nom',
      name: 'Nom de la tuile',
      appearance: 'Apparence',
      backgroundColor: 'Couleur de fond',
      flat: 'Plate',
      bordered: 'Bordée',
      square: 'Carrée',
      headerFontSize: 'Taille de police',
      headerAlign: 'Alignement du titre',
      cssClass: 'Classe CSS',
      layout: 'Disposition',
      x: 'X',
      y: 'Y',
      width: 'Largeur',
      height: 'Hauteur',
      advancedEdit: 'Modifier dans la boîte de dialogue',
      configureHint: 'Configurer cette tuile dans le panneau de droite',
      nestedDashboards: 'Tableaux de bord imbriqués',
      editNestedDashboard: 'Modifier ce tableau de bord imbriqué',
      duplicated: 'Tuile dupliquée'
    },
    tabs: {
      tile: 'Tuile',
      dashboard: 'Fonctionnalité',
      parameters: 'Paramètres',
      queries: 'Requêtes',
      children: 'Fonctionnalités enfants',
      copilot: 'Copilote'
    },
    children: {
      empty:
        'Aucune fonctionnalité enfant. Ajoutez des fonctionnalités avec cette fonctionnalité comme parent, ou configurez les onglets explicitement.'
    },
    copilot: {
      welcomeTitle: 'Copilote de fonctionnalité',
      welcomeSubtitle:
        "Demandez-moi d'ajouter des tuiles, de modifier des requêtes ou de restyler ce tableau de bord.",
      welcomeSubtitleTabs:
        'Demandez-moi de modifier les onglets, l’en-tête ou les paramètres de cette fonctionnalité.'
    },
    addTile: 'Ajouter une tuile',
    tileCatalog: {
      filter: 'Filtrer les types de tuiles',
      noResults: 'Aucune tuile ne correspond à votre recherche'
    }
  },
  fabricTree: {
    lakehouse: 'Lakehouse',
    folder: 'Dossier',
    file: 'Fichier',
    noItems: 'Aucun élément disponible'
  },
  twinMoveDialog: {
    title: 'Déplacer {count} jumeau | Déplacer {count} jumeaux',
    subtitle: 'Gérer les relations parent-enfant',
    removeRels: 'Supprimer les relations entrantes',
    optional: 'facultatif',
    addRels: 'Ajouter de nouvelles relations',
    newParent: 'Nouveau(x) parent(s) jumeau(x)',
    relType: 'Type de relation',
    relTypeAll: 'Toutes les relations seront créées en tant que {name}',
    onlyOption: 'seule option',
    move: 'Déplacer',
    relIdGen: 'ID de relation',
    relIdGenUid: 'Auto-généré (UUID)',
    relIdGenSourceTarget: 'Modèle Source-Cible'
  },
  profile: {
    title: 'Mon profil',
    description: 'Gérez vos coordonnées et la manière dont la plateforme vous notifie.',
    contactDetails: 'Coordonnées',
    email: 'E-mail',
    phoneNumber: 'Numéro de téléphone mobile',
    phoneNumberHint: 'Format international, indicatif pays inclus (par exemple +32470000000)',
    phoneNumberInvalid:
      'Saisissez votre numéro au format international, indicatif pays inclus (par exemple +32470000000)',
    smsTitle: 'Notifications SMS',
    smsOptionalBadge: 'Facultatif',
    smsIntro:
      "Les flux de la plateforme peuvent vous envoyer un SMS lorsque quelque chose requiert votre attention. C'est entièrement facultatif : vous pouvez utiliser la plateforme Arcadis Digital Twins sans cela, et cela ne fait pas partie des conditions générales que vous avez acceptées.",
    smsConsentLabel:
      "Oui, j'accepte de recevoir des notifications SMS d'Arcadis Digital Twins au numéro de téléphone ci-dessus.",
    smsPhoneRequired: "Ajoutez d'abord votre numéro de téléphone mobile pour pouvoir consentir.",
    smsFrequency:
      "Fréquence des messages : alertes et notifications occasionnelles déclenchées par les flux configurés pour votre environnement. Nous n'envoyons pas de messages marketing récurrents.",
    smsRates: "Des frais de message et de données peuvent s'appliquer.",
    smsOptOut: "Répondez STOP pour annuler à tout moment. Répondez HELP pour obtenir de l'aide.",
    smsLinks: 'Comment nous traitons vos données :',
    privacyPolicy: 'Politique de confidentialité',
    termsAndConditions: 'Conditions générales',
    smsOptedInSince: 'Vous avez donné votre consentement le {date}.',
    smsNotOptedIn: 'Vous ne recevez pas de notifications SMS.',
    saved: 'Vos préférences ont été enregistrées.',
    saveFailed: "Vos préférences n'ont pas pu être enregistrées. Veuillez réessayer.",
    loadFailed: "Votre profil n'a pas pu être chargé. Veuillez réessayer."
  },
  twinEditProperty: {
    smsRecipients: {
      label: 'Destinataires',
      hint: "Seuls les utilisateurs disposant d'un numéro de téléphone et ayant consenti aux notifications SMS sont listés",
      noRecipients:
        "Aucun utilisateur de cet environnement n'a encore consenti aux notifications SMS",
      unknownRecipient: 'Destinataire inconnu',
      expressionInUse: 'Cette activité utilise une expression pour déterminer les destinataires.',
      useRecipientList: 'Sélectionner des utilisateurs à la place'
    },
    secretFields: {
      sas: 'SAS',
      username: "Nom d'utilisateur",
      password: 'Mot de passe', // NOSONAR - This is a label, not a real password field
      clientId: 'ID client',
      clientSecret: 'Secret client',
      apiKey: 'Clé API',
      sharedKeyName: 'Nom de la clé partagée',
      sharedKey: 'Clé partagée',
      token: 'Jeton',
      refreshToken: "Jeton d'actualisation",
      authBody: "Corps de la requête d'authentification",
      authHeaders: "En-têtes de la requête d'authentification (JSON)"
    }
  }
}
